import { panelConstants } from "./panel.constants";

const initialState = {
  sidebarShow: 'responsive',
}

const panel = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case panelConstants.SET_PANEL_CONFIG:
      return { ...state, ...rest }
    default:
      return state
  }
}

export default panel;
